import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export function useUpdateVoiceProfile(entityId: string) {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (profile: Record<string, unknown>) => {
      const client = createApiClient(getToken);
      await client.put(`api/v2/entities/${entityId}/voice-profile`, {
        json: profile,
      });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['entity', entityId] }),
  });
}
